import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/nedflex.webp';
import screenshot_target from '../../../images/letterfunnel/nickbos.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Nick Bos"
      firstname="Nick"
      companyname="Nedflex"
      competition="Please en Pay for People"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/nickbos.js